// Late-bound links between modules, so travel and the gimmicks can call each other
// without importing in a circle.
export const hooks = {};
